// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"7f9d64db","314":"a746aab1","513":"db03c571","706":"cc727622","889":"e8aadfdb"}[chunkId] + ".chunk.js";
};